// extracted by mini-css-extract-plugin
export default {"cls1":"StyledComponents-LoginSubHeader_cls1__d6tjJ","cls2":"StyledComponents-LoginSubHeader_cls2__cE7NS StyledComponents-LoginSubHeader_cls1__d6tjJ"};